<div id="dialog_container" class="large-dialog-container">
  <div id="upper_band" class="upper-band upper-band-color"></div>
  <div id="middle_band" class="align-icon">
    <img
      id="warning_icon"
      src="/assets/images/warning-icon.svg"
      alt="Warning"
      width="100"
      class="image-icon" />
    <span class="text-content">
      <div id="title" class="title">Confirm Password Deletion</div>
      <div id="message" class="message">This action cannot be undone.</div>
    </span>
  </div>
  <div id="consequence_container" class="shared-container consequence-container">
    <span id="consequence_1">- All customer login credentials will be removed.</span>
    <span id="consequence_2"
      >- Customer will transition to using Identity Provided authentication</span
    >
    <span id="consequence_3">- Customers future logins will use their IDP credentials</span>
  </div>
  <div id="checkbox_container" class="shared-container checkbox-container">
    <span id="radio_button_label">Select Users for Password Deletion</span>
    <div
      id="check-holder-users"
      class="check-holder"
      [ngClass]="{ 'check-holder-active': isUsersSelected() }">
      <mat-checkbox
        id="users_admins_check"
        class="users-check"
        (change)="isUsersSelected.set($event.checked)">
        Users &amp; Admins
      </mat-checkbox>
    </div>
    <div
      id="check-holder-crew"
      class="check-holder"
      [ngClass]="{ 'check-holder-active': isCrewSelected() }">
      <mat-checkbox
        id="crew_check"
        class="users-check cus-check"
        (change)="isCrewSelected.set($event.checked)">
        Crew Users
      </mat-checkbox>
    </div>
  </div>
  <div id="warning_container" class="shared-container error-container">
    <span id="warning_title" class="warning-title">Warning :</span>
    <span id="warning_1"
      >The customer will lose all saved passwords for their users. After deletion, the customer will
      user their Identity provider passwords and will log in using their Identity Provider for
      authentication.
    </span>
    <span id="warning_2"
      >Ensure the customer has access to their Identity Provider before proceeding.</span
    >
    <span id="warning_3"
      >Type <span class="confirmation-word">{{ confirmationWord() }}</span> to confirm</span
    >
    <input
      matInput
      id="confirmation_input"
      class="shared-input-field"
      maxlength="50"
      autocomplete="off"
      (input)="onInput($event.target.value)"
      (paste)="$event.preventDefault()" />
  </div>
  <hr />
  <div id="lower_band" class="lower-band">
    <button
      mat-button
      id="edit_button"
      class="blue-button common-button delete-all-passwords-button"
      [disabled]="!isButtonEnabled()"
      [ngClass]="{ 'invalid-button': !isButtonEnabled() }"
      (click)="deletePasswords()">
      Delete All Passwords
    </button>
    <button
      mat-button
      id="cancel_button"
      class="white-button common-button"
      (click)="dialog.close()">
      Cancel
    </button>
  </div>
</div>
